module.exports = __webpack_public_path__ + "static/media/diamonds_2.e8becf50.png";